module.exports = __webpack_public_path__ + "img/culla_interbaby.31701bd9.jpg";